import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

export default function CustomInput({
  variant,
  label,
  isSmall,
  onChange,
  name,
  value,
  isNumberInput,
}) {
  return (
    <TextField
      sx={{
        height: "50px",
        padding: 0,
        margin: 1,
        width: isSmall ? "6ch" : "15ch",
        color: "red",
        "& .MuiInputBase-input": {
          color: "white", // Change the text color
        },
        "& .MuiInputLabel-root": {
          color: "blue", // Change the label color
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "white", // Change the border color
          },
          "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
            {
              "-webkit-appearance": "none",
              margin: 0,
            },
          '& input[type="number"]': {
            "-moz-appearance": "textfield",
          },
        },
      }}
      color="info"
      id="outlined-basic"
      label={label}
      variant={variant}
      size="small"
      onChange={onChange}
      name={name}
      value={value || ""}
      type={isNumberInput ? "number" : "text"}
      className="no-spinners"
    />
  );
}
